export const OptionMode = {
    ingredients: "INGREDIENTS",
    products: "PRODUCTS",
};

export const getOptionModeLabel = (type) => {
    switch (type) {
        case OptionMode.ingredients:
            return "Ingrédients";
        case OptionMode.products:
            return "Produits";
        default:
            return "Ingrédients";
    }
};

export const PaymentTypeList = [
    { _id: true, label: "Oui", labelKey: "common.yes" },
    { _id: false, label: "Non", labelKey: "common.no" },
];

export const ChoiceTypeList = [
    { _id: true, label: "Multiple", labelKey: "filters.multiple" },
    { _id: false, label: "Seul", labelKey: "filters.single" },
];

export const OptionModeList = [
    { _id: OptionMode.ingredients, label: getOptionModeLabel(OptionMode.ingredients), labelKey: "filters.ingredients" },
    { _id: OptionMode.products, label: getOptionModeLabel(OptionMode.products), labelKey: "filters.products" },
];